import React, { useState } from 'react';

const PreviewCard = ({ formData, originalMetadata }) => {
  const [copied, setCopied] = useState(false);
  const [isCompact, setIsCompact] = useState(false);

  const generateSharingLinks = () => {
    const { postUrl, title } = formData;
    const selectedPlatforms = Object.entries(formData.platforms)
      .filter(([_, selected]) => selected)
      .map(([platform, _]) => platform);

    const platformUrls = {
      bluesky: `https://bsky.app/intent/compose?text=${encodeURIComponent(title + (formData.excerpt ? ' - ' + formData.excerpt : '') + ' ' + postUrl)}`,
      threads: `https://www.threads.com/intent/post?text=${encodeURIComponent(title + ': ' + (formData.excerpt || '') + ' ' + postUrl)}`,
      facebook: `https://www.facebook.com/sharer.php?u=${encodeURIComponent(postUrl)}`,
      mastodon: `https://tootpick.org/#text=${encodeURIComponent(title + (formData.excerpt ? ' - ' + formData.excerpt : '') + ' ' + postUrl)}`,
      reddit: `https://reddit.com/submit?url=${encodeURIComponent(postUrl)}&title=${encodeURIComponent(title)}`,
      linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(postUrl)}`,
      email: `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent((formData.excerpt ? formData.excerpt + '\n\n' : '') + postUrl)}`
    };

    return selectedPlatforms.map(platform => ({
      platform,
      url: platformUrls[platform]
    }));
  };

  const generateHTMLSnippet = () => {
    const sharingLinks = generateSharingLinks();
    const { accentColor } = formData;
    
    const platformIcons = {
      bluesky: '<img src="https://sws-newsletter-share-buttons.netlify.app/icons/bluesky_white.png" width="16" height="16" alt="Bluesky" style="margin-right: 5px; margin-top: 4px; border-radius: 0;" />',
      threads: '<img src="https://sws-newsletter-share-buttons.netlify.app/icons/threads_white.png" width="16" height="16" alt="Threads" style="margin-right: 5px; margin-top: 4px; border-radius: 0;" />',
      facebook: '<img src="https://sws-newsletter-share-buttons.netlify.app/icons/facebook_white.png" width="16" height="16" alt="Facebook" style="margin-right: 5px; margin-top: 4px; border-radius: 0;" />',
      mastodon: '<img src="https://sws-newsletter-share-buttons.netlify.app/icons/mastodon_white.png" width="16" height="16" alt="Mastodon" style="margin-right: 5px; margin-top: 4px; border-radius: 0;" />',
      reddit: '<img src="https://sws-newsletter-share-buttons.netlify.app/icons/reddit_white.png" width="16" height="16" alt="Reddit" style="margin-right: 5px; margin-top: 4px; border-radius: 0;" />',
      linkedin: '<img src="https://sws-newsletter-share-buttons.netlify.app/icons/linkedin_white.png" width="16" height="16" alt="LinkedIn" style="margin-right: 5px; margin-top: 4px; border-radius: 0;" />',
      email: '<img src="https://sws-newsletter-share-buttons.netlify.app/icons/email_white.png" width="16" height="16" alt="Email" style="margin-right: 5px; margin-top: 4px; border-radius: 0;" />'
    };

    const platformIconsCompact = {
      bluesky: '<img src="https://sws-newsletter-share-buttons.netlify.app/icons/bluesky.png" width="16" height="16" alt="Bluesky" style="margin-left: 3px; margin-right: 3px; border-radius: 0;" />',
      threads: '<img src="https://sws-newsletter-share-buttons.netlify.app/icons/threads.png" width="16" height="16" alt="Threads" style="margin-left: 3px; margin-right: 3px; border-radius: 0;" />',
      facebook: '<img src="https://sws-newsletter-share-buttons.netlify.app/icons/facebook.png" width="16" height="16" alt="Facebook" style="margin-left: 3px; margin-right: 3px; border-radius: 0;" />',
      mastodon: '<img src="https://sws-newsletter-share-buttons.netlify.app/icons/mastodon.png" width="16" height="16" alt="Mastodon" style="margin-left: 3px; margin-right: 3px; border-radius: 0;" />',
      reddit: '<img src="https://sws-newsletter-share-buttons.netlify.app/icons/reddit.png" width="16" height="16" alt="Reddit" style="margin-left: 3px; margin-right: 3px; border-radius: 0;" />',
      linkedin: '<img src="https://sws-newsletter-share-buttons.netlify.app/icons/linkedin.png" width="16" height="16" alt="LinkedIn" style="margin-left: 3px; margin-right: 3px; border-radius: 0;" />',
      email: '<img src="https://sws-newsletter-share-buttons.netlify.app/icons/email.png" width="16" height="16" alt="Email" style="margin-left: 3px; margin-right: 3px; border-radius: 0;" />'
    };

    const platformNames = {
      bluesky: 'Bluesky',
      threads: 'Threads',
      facebook: 'Facebook',
      mastodon: 'Mastodon',
      reddit: 'Reddit',
      linkedin: 'LinkedIn',
      email: 'Email'
    };

    const buttonsHTML = sharingLinks.map(({ platform, url }) => 
      `<a href="${url}" class="newsletter-share-button-expanded" target="_blank" rel="noopener noreferrer" style="display: inline-block; margin: 8px; padding: 10px 15px; background: ${accentColor}; color: white; text-decoration: none; border-radius: 5px; font-family: Arial, sans-serif;">
        ${platformIcons[platform]} Share on ${platformNames[platform]}
      </a>`
    ).join('\n');

    if (isCompact) {
      return `<!-- Compact Social Sharing Section -->
<div style="margin: 20px 0; padding: 15px; border: 1px solid ${accentColor}; border-radius: 8px; background: ${accentColor}10;">
  <div style="" class="compact-social-buttons-container">
    <span style="color: #333; font-weight: 500; font-size: 16px;">Share this post:</span>
    ${sharingLinks.map(({ platform, url }) => 
      `<a href="${url}" class="newsletter-share-button-compact" target="_blank" rel="noopener noreferrer" style="display: inline-block; margin: 0 8px; color: #333; text-decoration: none; padding: 4px; border-radius: 4px; transition: background-color 0.2s;" onmouseover="this.style.backgroundColor='#f0f0f0'" onmouseout="this.style.backgroundColor='transparent'">
        ${platformIconsCompact[platform]}
      </a>`
    ).join('\n')}
  </div>
</div>`;
    } else {
      return `<!-- Expanded Social Sharing Section -->
<div style="margin: 20px 0; padding: 20px; border-top: 2px solid ${accentColor}; border-bottom: 2px solid ${accentColor}; background: ${accentColor}15;">
  <h3 style="color: #333; margin-top: 0;margin-bottom: 15px; text-align: center; font-size: 20px;">Share this post</h3>
  <div class="social-buttons-container" style="text-align: center;">
    ${buttonsHTML}
  </div>
</div>

`;
    }
  };

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(generateHTMLSnippet());
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  };

  const htmlSnippet = generateHTMLSnippet();

  return (
    <div className="preview-container">

        <div style={{ marginBottom: '2rem' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
            <h3 style={{ margin: 0, color: '#333', display: 'flex', alignItems: 'center' }}>Sharing Section Preview:</h3>
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <label style={{ fontSize: '0.9rem', color: '#666', display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                <input 
                  type="radio" 
                  name="style" 
                  checked={!isCompact} 
                  onChange={() => setIsCompact(false)}
                  style={{ marginRight: '6px' }}
                />
                Expanded
              </label>
              <label style={{ fontSize: '0.9rem', color: '#666', display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                <input 
                  type="radio" 
                  name="style" 
                  checked={isCompact} 
                  onChange={() => setIsCompact(true)}
                  style={{ marginRight: '6px' }}
                />
                Compact
              </label>
            </div>
            <button 
              onClick={copyToClipboard} 
              className={`copy-button ${copied ? 'copied' : ''}`}
              style={{
                padding: '8px 16px',
                fontSize: '0.9rem',
                background: copied ? '#28a745' : '#667eea',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                transition: 'background-color 0.2s',
                height: 'fit-content',
                display: 'flex',
                alignItems: 'center',
                margin: 0
              }}
            >
              {copied ? 'Copied!' : 'Copy HTML Code'}
            </button>
          </div>
        </div>
        <p style={{ margin: '0 0 1rem 0', color: '#666', fontSize: '0.9rem' }}>
          Click 'Copy HTML Code' and then paste it into an HTML card in your Ghost post.
        </p>
        <div 
          style={{ 
            border: '1px solid #ddd', 
            borderRadius: '8px', 
            padding: '20px', 
            background: '#f9f9f9',
            maxWidth: '600px',
            margin: '0 auto'
          }}
          dangerouslySetInnerHTML={{ __html: htmlSnippet }}
        />
      </div>

      <div style={{ marginBottom: '2rem' }}>
        <h3 style={{ marginBottom: '1rem', color: '#333' }}>Social Media Preview: (no promises!)</h3>
        <div 
          style={{ 
            border: '1px solid #ddd', 
            borderRadius: '8px', 
            padding: '20px', 
            background: '#f9f9f9',
            maxWidth: '500px',
            margin: '0 auto'
          }}
        >
          <div style={{ 
            border: '1px solid #ccc', 
            borderRadius: '8px', 
            padding: '15px', 
            background: 'white',
            maxWidth: '400px',
            margin: '0 auto'
          }}>
            {originalMetadata?.image && (
              <img 
                src={originalMetadata.image} 
                alt={originalMetadata.title || 'Link preview'} 
                style={{ 
                  width: '100%', 
                  height: '200px', 
                  objectFit: 'cover', 
                  borderRadius: '4px', 
                  marginBottom: '10px' 
                }} 
              />
            )}
            <h4 style={{ margin: '0 0 8px 0', fontSize: '1.1rem', color: '#333' }}>
              {originalMetadata?.title || 'Link Preview'}
            </h4>
            {originalMetadata?.description && (
              <p style={{ margin: '0 0 8px 0', color: '#666', fontSize: '0.9rem', lineHeight: '1.4' }}>
                {originalMetadata.description}
              </p>
            )}
            <p style={{ margin: '0', color: '#999', fontSize: '0.8rem' }}>
              {formData.postUrl}
            </p>
          </div>
        </div>
      </div>
      <div>
        <h3 style={{ marginBottom: '1rem', color: '#333', marginTop: '2rem' }}>Optional Styles for Web:</h3>
        <div className="html-snippet">
          <pre>
{`<style>
  .newsletter-share-button-expanded {
     display: flex!important; 
     flex-direction: row; 
     align-items: baseline!important;
  }
  .social-buttons-container {
     display: flex!important; 
     flex-direction: row; 
     flex-wrap: wrap; 
     justify-content: center;
  }
  .compact-social-buttons-container {
    display: flex!important;
    flex-direction: row!important;
    flex-wrap: wrap!important;
    justify-content: center!important;
  }
</style>  
`}
</pre>
        </div>
        <p style={{ margin: '0 0 1rem 0', color: '#666', fontSize: '0.9rem' }}>
          If you're also publishing your post to the web, you'll probably need the styles above. 
          Do not embed them in an HTML card or they'll mess up your email formatting. Add them as code injection or integrate into your theme.

        </p>
      </div>
      <div>
        <h3 style={{ marginBottom: '1rem', color: '#333' }}>HTML Code:</h3>
        <div className="html-snippet">
          {htmlSnippet}
        </div>
      </div>
      
    </div>
  );
};

export default PreviewCard;
